module.exports = __webpack_public_path__ + "static/media/tablesIcon.svg";